/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../nls/StringResources',
	'react',
	'prop-types',
	'./DataSourcePanelPage',
	'../DataSourcePanelStatic',
	'../../../../lib/@waca/dashboard-common/dist/lib/@ba/ba-graphics/dist/icons-js/add_32'
], function (_, StringResources, React, PropTypes, DataSourcePanelPage, DataSourcePanelStatic, add16) {

	const add = add16.default;

	const GLASS_COLLECTION__BUTTONS = 'com.ibm.bi.dashboard.dataSourcePanel.list.buttons';

	class DataSourcePanelEmpty extends DataSourcePanelPage {
		static propTypes = {
			onAddDataSource: PropTypes.func.isRequired
		};

		getTitleParams() {
			return {
				id: 'empty',
				title: StringResources.get('dataPaneLabel')
			};
		}

		getButtonCollectionId() {
			return GLASS_COLLECTION__BUTTONS;
		}

		renderPanel() {
			return (
				<DataSourcePanelStatic
					className='dataSourcePanelEmpty'
					iconType={DataSourcePanelStatic.ICON_TYPES.default}
					title={StringResources.get('emptySourcePaneTitle')}
					caption={StringResources.get('emptySourcePaneCaption')}
					button={{
						label: StringResources.get('addDataSource'),
						icon: add.id,          //TODO: Use icon service
						intent: 'primary',
						onClick: () => this.props.onAddDataSource()
					}}
				/>
			);
		}
	}

	return DataSourcePanelEmpty;
});
